export default __webpack_public_path__ + "static/media/Bars-1s-200px.f8948b1c.gif";